import React from 'react';
import { fetchUserMvp, getActiveCode, getBuddyYouthCommunity, mvpSignUp } from 'redux/actions/user.action';
import { connect } from 'react-redux';
import './signin.scss';
import { Redirect } from 'react-router-dom';
import { I18n } from '../../helpers/i18n';
import arrowBackIcon from 'static/images/mvp/black-arrow-left.png';
import { toast } from 'react-toastify';
import {
  FormSection,
  SectionBody,
  SectionFooter,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import SignUpBuddyInfo from './SignUpBuddyInfo';
import SignUpSeniorInfo from './SignUpSeniorInfo';
import warning from '../../static/images/mvp/warning.png';

const SENIOR = 'senior';
const BUDDY = 'seniorBuddy';
const HEALTH_STATUS_DEFAULT = 'normal';
const BUDDY_YOUTH_COMMUNITY = 'N/A';
const INPUTS = {
  ['name']: '',
  ['password']: '',
  ['rePassword']: '',
  ['email']: '',
  ['healthNote']: '',
  ['relativeName']: '',
  ['relativeEmail']: '',
  ['giftCode']: '',
};
class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.inputs = { ...INPUTS };
    this.intervalId = null;
    this.state = {
      time: 120,
      type: '',
      errorEmail: '',
      errorOtp: '',
      errorName: '',
      errorPassword: '',
      errorRePassword: '',
      errorNote: '',
      errorRelativeName: '',
      errorGiftCode: '',
      errorRelativeEmail: '',
      step: 1,
      nextStep: 1,
      redirectToReferrer: false,
      redirectToHome: false,
      getOtpSuccess: true,
      listBuddyYouthCommunity: [
        {
          value: '',
          label: I18n.t('youth_community'),
        },
      ],
      healthStatusList: [
        {
          value: HEALTH_STATUS_DEFAULT,
          label: I18n.t('health_normal'),
        },
        {
          value: 'needSupport',
          label: I18n.t('health_need_support'),
        },
      ],
      youthCommunity: '',
      healthStatus: HEALTH_STATUS_DEFAULT,
    };

    this.nextStep = this.nextStep.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getOtpVerify = this.getOtpVerify.bind(this);
    this.signUp = this.signUp.bind(this);
    this.reGetOtpVerify = this.reGetOtpVerify.bind(this);
  }

  async componentDidMount() {
    const { getBuddyYouthCommunity } = this.props;
    getBuddyYouthCommunity().then((rs) => {
      this.setState({ listBuddyYouthCommunity: rs });
    });
  }

  componentWillUnmount() {
    clearInterval(this.intervalId); // Dọn dẹp interval khi component bị unmount
  }

  startCountdown = () => {
    this.intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.time <= 0) {
          clearInterval(this.intervalId);
          return { time: 0 };
        }
        return { time: prevState.time - 1 };
      });
    }, 1000);
  };

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  handleKeyDown = (event) => {
    this.moveFocus('prev', event);
  };

  handleInput = (event) => {
    if (!/^\d$/.test(event.target.value)) {
      event.target.value = '';
      return;
    }
    this.moveFocus('next', event);
    event.target.style.animation = 'none';
    event.target.offsetHeight; /* trigger reflow */
    event.target.style.animation = null;
  };

  moveFocus(direction, event = null) {
    const inputs = document.querySelectorAll('.verification-container input');
    const index = Array.prototype.indexOf.call(inputs, event.target);

    if (direction === 'next' && event.target.value.length === 1) {
      if (index < inputs.length - 1) {
        inputs[index + 1].focus();
      }
    }

    if (direction === 'prev' && event.key === 'Backspace' && !event.target.value) {
      if (index > 0) {
        inputs[index - 1].focus();
      }
    }
  }

  handleSelectHealthStatus = (data) => {
    this.setState({ healthStatus: data });
  };

  handleSelectCommunity = (data) => {
    this.setState({ youthCommunity: data });
  };

  clearError() {
    this.setState({ errorEmail: '' });
    this.setState({ errorPassword: '' });
    this.setState({ errorRePassword: '' });
    this.setState({ errorNote: '' });
    this.setState({ errorRelativeName: '' });
    this.setState({ errorGiftCode: '' });
    this.setState({ errorRelativeEmail: '' });
    this.setState({ errorName: '' });
    this.setState({ errorOtp: '' });
    this.setState({ time: 120 });
  }

  clearAllData() {
    this.clearError();
    this.setState({ youthCommunity: '' });
    this.setState({ healthStatus: HEALTH_STATUS_DEFAULT });
    this.inputs = { ...INPUTS };
  }

  verifyInput = () => {
    const { email, name, password, rePassword } = this.inputs;
    let verify = true;
    if (!email) {
      verify = false;
      this.setState({ errorEmail: I18n.t('text_field_required_error') });
    }
    if (email && !this.validateEmail(email)) {
      verify = false;
      this.setState({ errorEmail: I18n.t('email_invalid') });
    }
    if (!name) {
      verify = false;
      this.setState({ errorName: I18n.t('text_field_required_error') });
    }
    if (!password) {
      verify = false;
      this.setState({ errorPassword: I18n.t('text_field_required_error') });
    }
    if (!rePassword) {
      verify = false;
      this.setState({ errorRePassword: I18n.t('text_field_required_error') });
    }
    return verify;
  };

  verifySenior = () => {
    const { relativeName, relativeEmail } = this.inputs;
    let verify = this.verifyInput();
    if (!relativeName) {
      verify = false;
      this.setState({ errorRelativeName: I18n.t('text_field_required_error') });
    }
    if (!relativeEmail) {
      verify = false;
      this.setState({ errorRelativeEmail: I18n.t('text_field_required_error') });
    }
    if (relativeEmail && !this.validateEmail(relativeEmail)) {
      verify = false;
      this.setState({ errorRelativeEmail: I18n.t('email_invalid') });
    }
    if (verify) {
      this.clearError();
    }
    return verify;
  };

  verifyBuddy = () => {
    let verify = this.verifyInput();
    if (verify) {
      this.clearError();
    }
    return verify;
  };

  async nextStep() {
    let { type, step, nextStep } = this.state;
    if (!type) {
      return;
    }
    nextStep += 1;
    const funcFactory = {
      [BUDDY]: this.verifyBuddy,
      [SENIOR]: this.verifySenior,
    };
    let verify = true;
    if (step === 2 && nextStep > step) {
      verify = funcFactory[type] ? funcFactory[type]() : true;
    }
    if (!verify) {
      return;
    }
    if (nextStep === 3) {
      await this.getOtpVerify();
    }
    if (!this.state.getOtpSuccess) {
      return;
    }
    this.setState({ step: step + 1 });
    this.setState({ nextStep: nextStep });
  }

  async signUp() {
    const inputs = document.querySelectorAll('.verification-container input');
    this.setState({ errorOtp: '' });
    this.setState({ time: 0 });
    clearInterval(this.intervalId);
    let otp = '';
    inputs.forEach((input) => {
      if (!input.value.trim()) {
        this.setState({ errorOtp: I18n.t('incorrect_verification_code') });
        return;
      }
      otp += input.value.trim();
    });

    if (this.state.errorOtp) {
      return;
    }

    const { mvpSignUp, fetchUserMvp } = this.props;
    const { email, password, name, healthNote, relativeName, relativeEmail, giftCode } = this.inputs;
    const params = {
      email: email,
      type: this.state.type,
      password: password,
      active_code: otp,
      name: name,
      youthCommunity: this.state.youthCommunity || BUDDY_YOUTH_COMMUNITY,
    };

    if (this.state.type === SENIOR) {
      params['giftCode'] = giftCode
      params['healthStatus'] = this.state.healthStatus;
      params['healthNote'] = healthNote;
      params['infoFamily'] = {
        name: relativeName,
        phone: '',
        email: relativeEmail,
        relation: '',
      };
    }
    return mvpSignUp(params)
      .then((result) => {
        if (result.status === 'OK') {
          // save to storage
          let dataUser = {
            name: result.user.name,
            _id: result.user._id,
            accessToken: result.accessToken,
          };
          localStorage.setItem('user-info', JSON.stringify(dataUser));
          fetchUserMvp();
          toast.success(I18n.t('registered_successful'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            closeButton: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            className: 'toast-error-container toast-error-container-after',
            theme: 'colored',
          });
          this.setState({ redirectToHome: true });
        } else {
          this.setState({ errorOtp: result.message });
        }
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  async reGetOtpVerify() {
    const inputs = document.querySelectorAll('.verification-container input');
    inputs?.forEach((input) => {
      input.value = '';
    });
    await this.getOtpVerify();
  }

  async getOtpVerify() {
    const { email, password, name, giftCode } = this.inputs;
    const { type } = this.state;
    this.setState({ getOtpSuccess: true });
    this.setState({ time: 120 });
    this.setState({ errorOtp: '' });
    this.setState({ errorGiftCode: '' });
    clearInterval(this.intervalId);
    this.startCountdown();
    await this.props.getActiveCode(email, password, type, name, giftCode).then((res) => {
      if (res.status !== 'OK') {
        clearInterval(this.intervalId);
        this.setState({ getOtpSuccess: false });
        this.setState({ time: 0 });
        if (res.type === 'inline') {
          this.setState({ errorGiftCode: res.message });
          return
        }
        toast.error(`${res.message}`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          closeButton: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          className: 'toast-error-container toast-error-container-after',
          theme: 'colored',
        });
      }
    });
  }

  handleBack() {
    let { step } = this.state;
    if (step !== 1) {
      step -= 1;
      this.setState({ step: step });
      this.setState({ nextStep: step });
      if (step === 1) {
        this.clearAllData();
      }
      return;
    }
    this.setState({ redirectToReferrer: true });
  }

  handleChooseType = (value) => {
    this.setState({ type: value });
  };

  handleInputChange(evt) {
    this.inputs = this.inputs || { ...INPUTS };
    const { name, value, type, checked } = evt.target;
    const check_type = ['radio', 'checkbox'].includes(type);
    this.inputs[name] = check_type ? checked : value;
    this.inputs['checkedValue'] = check_type ? value : null;
    const password = this.inputs.password;
    const rePassword = this.inputs.rePassword;
    if (password && rePassword && password !== rePassword) {
      this.setState({ errorRePassword: I18n.t('repeat_password_match') });
    } else {
      this.setState({ errorRePassword: '' });
    }
  }

  getTitleByTitle = (title) => {
    const TYPE_TITLE = {
      [SENIOR]: I18n.t('register_senior'),
      [BUDDY]: I18n.t('register_buddy'),
    };
    return TYPE_TITLE[title];
  }

  render() {
    const { redirectToReferrer, redirectToHome, step, type, time, errorOtp } = this.state;
    const isStepChooseType = step === 1;
    const isStepPersonal = step === 2;
    const isStepSignUpVerify = step === 3;
    const isSenior = isStepPersonal && type === SENIOR;
    const isBuddy = isStepPersonal && type === BUDDY;
    let typeTitle = this.getTitleByTitle(type) || I18n.t('account_type_selection_title');
    let buttonTitle = isStepChooseType ? I18n.t('continue_text') : I18n.t('register');
    if (isStepSignUpVerify) {
      typeTitle = I18n.t('verification_code');
      buttonTitle = I18n.t('verification_account');
    }

    if (redirectToReferrer === true) {
      return <Redirect to="/login" />;
    }

    if (redirectToHome === true) {
      return <Redirect to="/" />;
    }

    return (
      <div id="site_wrapper">
        {this.props.header}
        <div id="mvp-sign-up-modal">
          <FormSection style={{ width: '438px' }}>
            <div className="d-flex align-items-center mb-4">
              <img className="cursor-pointer" src={arrowBackIcon} alt="Arrow Back" onClick={this.handleBack} />
              <span className="title">{typeTitle}</span>
            </div>
            {isStepChooseType && (
              <SectionBody>
                <div
                  className={`card-sign-up senior mb-4 cursor-pointer ${this.state.type === SENIOR ? 'checked' : ''}`}
                  onClick={() => this.handleChooseType(SENIOR)}
                >
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <h5 className="mb-0">{I18n.t('account_type_selection_senior')}</h5>
                    <label>
                      <input type="checkbox" checked={this.state.type === SENIOR} />
                      <div className="outer-circle">
                        <div className="inner-circle"></div>
                      </div>
                    </label>
                  </div>
                  <span className="text-muted">
                    {I18n.t('account_type_selection_senior_des')}
                  </span>
                </div>
                <div
                  className={`card-sign-up buddy mb-4 cursor-pointer ${this.state.type === BUDDY ? 'checked' : ''}`}
                  onClick={() => this.handleChooseType(BUDDY)}
                >
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <h5 className="mb-0">{I18n.t('account_type_selection_senior_buddy')}</h5>
                    <label className="circle">
                      <input type="checkbox" checked={this.state.type === BUDDY} />
                      <div className="outer-circle">
                        <div className="inner-circle"></div>
                      </div>
                    </label>
                  </div>
                  <span className="text-muted">
                    {I18n.t('account_type_selection_senior_buddy_des')}
                  </span>
                </div>
              </SectionBody>
            )}
            {isBuddy && (
              <SignUpBuddyInfo
                {...this.state}
                {...this.inputs}
                onSelectCommunity={this.handleSelectCommunity}
                onInputChange={this.handleInputChange}
              />
            )}
            {isSenior && (
              <SignUpSeniorInfo
                {...this.state}
                {...this.inputs}
                onSelectHealthStatus={this.handleSelectHealthStatus}
                onInputChange={this.handleInputChange}
              />
            )}
            {isStepSignUpVerify && (
              <div className="d-flex flex-column">
                <span className="text-muted">{I18n.t('sent_to_email')}</span>
                <p style={{ textDecoration: 'underline' }}>{this.inputs.email}</p>
                <div className="verification-container">
                  <input type="text" maxLength="1" onInput={this.handleInput} onKeyDown={this.handleKeyDown} />
                  <input type="text" maxLength="1" onInput={this.handleInput} onKeyDown={this.handleKeyDown} />
                  <input type="text" maxLength="1" onInput={this.handleInput} onKeyDown={this.handleKeyDown} />
                  <input type="text" maxLength="1" onInput={this.handleInput} onKeyDown={this.handleKeyDown} />
                  <input type="text" maxLength="1" onInput={this.handleInput} onKeyDown={this.handleKeyDown} />
                </div>
                {errorOtp && (
                  <span className="error-message mt-1">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                    {errorOtp}
                  </span>
                )}
                {time > 0 && (
                  <div className="d-flex gap-2 mt-2">
                    <span className="text-muted mr-2">{I18n.t('resend_verification_code_after')} </span>
                    <p>{time}s</p>
                  </div>
                )}
                {time === 0 && (
                  <div className="d-flex gap-2 mt-2">
                    <span
                      onClick={this.reGetOtpVerify}
                      style={{ color: '#0564F1', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                      {I18n.t('resend_verification_code')}
                    </span>
                  </div>
                )}
              </div>
            )}
            <SectionFooter>
              {!isStepSignUpVerify && (
                <button onClick={this.nextStep} type="button" className="btn btn-warning next-step">
                  {I18n.t(`${buttonTitle}`)}
                </button>
              )}
              {isStepSignUpVerify && (
                <button
                  style={{ width: '100%', marginTop: '50px' }}
                  onClick={this.signUp}
                  type="button"
                  className="btn btn-warning next-step"
                >
                  {I18n.t(`${buttonTitle}`)}
                </button>
              )}
            </SectionFooter>
          </FormSection>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  userInfo: user,
});

const mapDispatchToProps = { getBuddyYouthCommunity, getActiveCode, fetchUserMvp, mvpSignUp };

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
